import { ApiProvider} from "@sb1finans/components/dist/ApiProvider"
import { CustomThemeProvider } from "@sb1finans/components/dist/themes/CustomThemeContext"
import React, { useEffect } from "react"
import ReactDOM from "react-dom"
import { SB1ErrorBoundary } from "@sb1finans/components/dist/Sb1ErrorBoundary"
import { createLogger, AppInsightsLogger, LogLevel, LoggerProvider } from "@sb1finans/components/dist/SB1Logger"
import { AppRouter } from "./AppRouter"
import { initializeAuthFromUrl } from "./initializeAuthFromUrl"
import { appConfig } from "./appConfig"

initializeAuthFromUrl()

let logger
if (process.env.NODE_ENV !== 'development') {
    console.log("Production environmenrt!")
    logger = createLogger({
        interceptors: [
            AppInsightsLogger({instrumentationKey: 'e2a8fa89-f6f6-4058-bd27-0a0714ade024'})
        ],
        captureConsole: true,
        logLevel: LogLevel.INFO
    })
} else {
    console.log("DEV environmenrt!")
    /*const worker = setupWorker(...handlers)
    worker.start()*/
    logger = createLogger({
        interceptors: [],
        captureConsole: true
    })
}

fetch("/config/config.json").then(response => response.json()).then(json => {
    console.log("Config is: ", json)
    return json
}).then((config) => {
    console.info("Initializing app mypage with config: ", config)

    ReactDOM.render(
        <React.StrictMode>
            <LoggerProvider logger={logger}>
                <SB1ErrorBoundary>
                    <CustomThemeProvider>
                        { <AppRouter config={config}/> }
                    </CustomThemeProvider>
                </SB1ErrorBoundary>
            </LoggerProvider>
        </React.StrictMode>,
    document.getElementById('root')
  )
  console.info("App mypage initialized.")
})
